"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _stringify = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/json/stringify"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _get2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/get"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _highcharts = _interopRequireDefault(require("highcharts"));

var _reactJsxHighcharts = require("react-jsx-highcharts");

var _reactSwipeableViews = _interopRequireDefault(require("react-swipeable-views"));

var _Voting = _interopRequireDefault(require("./Voting.scss"));

var _config = _interopRequireDefault(require("../../../../targets/cord_eurofh_teams/config.js"));

var _cssConstants = _interopRequireDefault(require("../../../../targets/cord_eurofh_teams/cssConstants.js"));

var _FeedbackService = require("../../../KESI2/Services/FeedbackService");

var _FeedbackReceiveStore = _interopRequireWildcard(require("../../../KESI2/Services/FeedbackService/Stores/FeedbackReceiveStore2"));

var _index = _interopRequireDefault(require("../Button/index"));

var _AlertHelper = require("../../../helpers/AlertHelper");

var _strings = require("./strings");

var _ArrayHelper = require("../../../helpers/ArrayHelper");

var _StoreComponent2 = _interopRequireDefault(require("../../../KESI2/Stores/StoreComponent"));

var _DataStore = _interopRequireWildcard(require("../../../KESI2/Stores/DataStore2"));

var _DeviceInfoHelper = _interopRequireDefault(require("../../../helpers/DeviceInfoHelper"));

var _ScreenHelper = _interopRequireDefault(require("../../../helpers/ScreenHelper"));

var _TimeoutHelper = require("../../../helpers/TimeoutHelper");

var _CssHelper = _interopRequireDefault(require("../../../helpers/CssHelper"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var Voting = /*#__PURE__*/function (_StoreComponent) {
  (0, _inherits2["default"])(Voting, _StoreComponent);

  var _super = _createSuper(Voting);

  function Voting(props, context) {
    var _thisSuper, _this;

    (0, _classCallCheck2["default"])(this, Voting);
    _this = _super.call(this, props, context);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_initAnswerLabels", function () {
      var chartData = [];
      var questionId = _this.props.questionId;

      _this.props.answers.forEach(function (answer, index) {
        console.log('_initAnswerLabels', answer);
        chartData.push({
          id: questionId + '_' + answer.id,
          text: answer.text,
          label: answer.label
        });
      });

      _this.chartData = chartData;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_updateAnswerValues", function (state) {
      if (state.answerStats) {
        _this.chartData.forEach(function (entry) {
          if (_config["default"].absoluteVoteResults) {
            if (state.answerStats.hasOwnProperty(entry.id)) {
              console.log('update answerstats for id', entry.id);
              entry.Stimmen = state.answerStats["".concat(entry.id, "_abs")];
            } else {
              entry.Stimmen = 0;
            }
          } else {
            if (state.answerStats.hasOwnProperty(entry.id)) {
              console.log('update answerstats for id', entry.id);
              entry.Prozent = state.answerStats[entry.id];
            } else {
              entry.Prozent = 0;
            }
          }
        });
      }

      _this.forceUpdate();

      _this.props.votingUpdated();
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "checkEnterKey", function (event) {
      if (event.key === 'Enter') {
        var el = document.activeElement;

        if (el) {
          if (el.id.indexOf('votingCheck_') > -1) {
            var indexParts = el.id.split('_');

            if (indexParts.length > 2) {
              var answerId = indexParts[2];

              var answer = _this.props.answers.find(function (a) {
                return a.id === answerId;
              });

              var currentlySelected = _this.state.selectedMCOptions;
              var index = currentlySelected.indexOf("".concat(_this.props.question.id, "_").concat(answer.id));

              if (index !== -1) {
                (0, _ArrayHelper.removeElementAtPosition)(currentlySelected, index);
              } else {
                currentlySelected.push("".concat(_this.props.question.id, "_").concat(answer.id));
              }

              console.log('currentlySelected', currentlySelected);

              _this.setState({
                selectedMCOptions: currentlySelected
              });
            }
          } else if (el.id.indexOf('votingRadio_') > -1) {
            var _indexParts = el.id.split('_');

            if (_indexParts.length > 2) {
              var _answerId = _indexParts[2];

              var _answer = _this.props.answers.find(function (a) {
                return a.id === _answerId;
              });

              _this.setState({
                selectedOption: _answer
              });
            }
          }
        }
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onWindowSizeChanged", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return (0, _TimeoutHelper.timeout)(500);

            case 2:
              console.log('Voting on windowSizeChanged', _this._chartContainer !== null ? _this._chartContainer.offsetWidth : 333);

              _this.setState({
                chartWidth: _this._chartContainer !== null ? _this._chartContainer.offsetWidth : 500
              });

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "renderAnswers", function () {
      console.log('voting answers', _this.props.answers);
      return _this.props.answers.map(function (answer) {
        var id = _this.props.questionId + '_' + answer.id;
        return _this.props.singleChoice ? /*#__PURE__*/_react["default"].createElement("li", {
          key: id,
          style: _this.props.displayInline ? {
            display: 'inline-block',
            width: "".concat(100 / _this.props.answers.length, "%")
          } : {}
        }, /*#__PURE__*/_react["default"].createElement("input", {
          type: "radio",
          name: _this.props.questionId,
          id: "votingRadio_".concat(id),
          value: answer.id,
          checked: _this.state.selectedOption && _this.state.selectedOption.id === answer.id,
          onClick: function onClick() {
            console.log('input click');

            _this.setState({
              selectedOption: answer
            });
          },
          style: _this.props.displayInline ? {
            left: '50%',
            transform: 'translateX(-50%)'
          } : {}
        }), /*#__PURE__*/_react["default"].createElement("label", {
          style: _this.props.displayInline ? {
            textAlign: 'center',
            paddingTop: '50px',
            width: '100%',
            paddingLeft: 0
          } : {
            width: '100%'
          },
          htmlFor: "votingRadio_".concat(id)
        }, answer.text), /*#__PURE__*/_react["default"].createElement("div", {
          id: "votingRadio_".concat(id),
          tabIndex: 0,
          className: _this.props.displayInline ? 'radioInline' : 'radio'
        })) : /*#__PURE__*/_react["default"].createElement("li", {
          key: id,
          style: _this.props.displayInline ? {
            display: 'inline-block',
            width: "".concat(100 / _this.props.answers.length, "%")
          } : {}
        }, /*#__PURE__*/_react["default"].createElement("input", {
          type: "checkbox",
          name: _this.props.questionId + '[]',
          id: "votingCheck_".concat(id),
          value: answer.id,
          onClick: function onClick() {
            var currentlySelected = _this.state.selectedMCOptions;
            var index = currentlySelected.indexOf("".concat(_this.props.questionId, "_").concat(answer.id));

            if (index !== -1) {
              (0, _ArrayHelper.removeElementAtPosition)(currentlySelected, index);
            } else {
              currentlySelected.push("".concat(_this.props.questionId, "_").concat(answer.id));
            }

            console.log('currentlySelected', currentlySelected);

            _this.setState({
              selectedMCOptions: currentlySelected
            });
          },
          style: _this.props.displayInline ? {
            left: '50%',
            transform: 'translateX(-50%)'
          } : {}
        }), "\xA0", /*#__PURE__*/_react["default"].createElement("label", {
          style: _this.props.displayInline ? {
            textAlign: 'center',
            paddingTop: '50px',
            width: '100%',
            paddingLeft: 0
          } : {
            width: 'calc(100% - 20px)'
          },
          htmlFor: "votingCheck_".concat(id)
        }, answer.text), /*#__PURE__*/_react["default"].createElement("div", {
          id: "votingCheck_".concat(id),
          tabIndex: 0,
          className: _this.props.displayInline ? 'checkInline' : 'check'
        }));
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "renderBarChart", function (width) {
      var renderData = _this.chartData ? _this.chartData.slice() : [];
      console.log('renderBarChart', renderData);
      var xAxisData = [];
      var series = [];
      renderData.forEach(function (entry) {
        xAxisData.push(entry.label ? entry.label : entry.text);
        series.push(_config["default"].absoluteVoteResults ? entry.Stimmen : entry.Prozent);
      });
      var labelObj = _DeviceInfoHelper["default"].isBrowser() ? {} : {
        padding: 10,
        overflow: 'allow',
        style: {
          textOverflow: 'none',
          whiteSpace: 'normal',
          formatter: function formatter() {
            return '<div align="center" style="word-wrap: break-word;word-break: break-all; width: 70px;">' + this.value + '</div>';
          }
        }
      };
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _Voting["default"].pieChart
      }, /*#__PURE__*/_react["default"].createElement(_reactJsxHighcharts.HighchartsChart, null, /*#__PURE__*/_react["default"].createElement(_reactJsxHighcharts.Chart, null), /*#__PURE__*/_react["default"].createElement(_reactJsxHighcharts.XAxis, {
        categories: xAxisData,
        labels: labelObj
      }), /*#__PURE__*/_react["default"].createElement(_reactJsxHighcharts.YAxis, {
        allowDecimals: !_config["default"].absoluteVoteResults,
        max: _config["default"].absoluteVoteResults ? null : 100
      }, /*#__PURE__*/_react["default"].createElement(_reactJsxHighcharts.YAxis.Title, null, _config["default"].absoluteVoteResults ? 'Stimmen' : 'Prozent'), /*#__PURE__*/_react["default"].createElement(_reactJsxHighcharts.ColumnSeries, {
        dataLabels: {
          enabled: true,
          style: {
            fontFamily: _cssConstants["default"].fontFamily,
            fontSize: '15px'
          }
        },
        color: _config["default"].useTileBackgroundColorInTile && _this.props.forcedUIColor ? _this.props.forcedUIColor : _cssConstants["default"].colors.buttonBackground,
        data: series
      }))));
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "sendAnswers", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
      var userAnswer;
      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              console.log('voting sendAnswers', _this.props.questionId, _this.state.selectedOption);

              if (_this.props.singleChoice) {
                if (_this.state.selectedOption) {
                  if (!_this.props.inSwipeContainer) {
                    _this.props.markAsRead(_this.props.questionId);
                  }

                  _this._sendChange("".concat(_this.props.questionId, "_").concat(_this.state.selectedOption.id));

                  _this.props.onVoted();
                } else {
                  if (!_this.props.inFeedbackContainer) {
                    (0, _AlertHelper.showWideAlertHtml)((0, _strings.getString)('NO_OPTION_CHOSEN'), (0, _strings.getString)('NO_OPTION_CHOSEN_TITLE'));
                  }
                }
              } else {
                if (_this.state.selectedMCOptions.length > 0) {
                  if (!_this.props.inSwipeContainer) {
                    _this.props.markAsRead(_this.props.questionId);
                  }

                  _this._sendChange();

                  _this.props.onVoted();
                } else {
                  if (!_this.props.inFeedbackContainer) {
                    (0, _AlertHelper.showWideAlertHtml)((0, _strings.getString)('NO_OPTION_CHOSEN'), (0, _strings.getString)('NO_OPTION_CHOSEN_TITLE'));
                  }
                }
              }

              if (!(_this.props.inFeedbackContainer && (_this.state.selectedOption || _this.state.selectedMCOptions.length > 0))) {
                _context2.next = 9;
                break;
              }

              // lets wait for a second and hope we have the updated results by then
              console.log(_this.state.selectedOption, _this.state.selectedMCOptions);
              _context2.next = 6;
              return (0, _TimeoutHelper.timeout)(500);

            case 6:
              userAnswer = _this.props.singleChoice ? _this.state.selectedOption ? _this.state.selectedOption.text : '' : null;
              console.log('userAnswer', userAnswer, _this.state.selectedOption);
              return _context2.abrupt("return", {
                id: _this.props.questionId,
                type: 'vote',
                data: _this.chartData,
                question: _this.props.question,
                userAnswer: userAnswer
              });

            case 9:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })));
    _this.chartData = []; // temporary

    _this.lastSend = null;
    _this._chartContainer = null;
    _this.state = {
      answerStats: {},
      voted: false,
      chosenAnswer: '',
      selectedOption: null,
      selectedMCOptions: [],
      index: 0,
      chartWidth: window.innerWidth * 0.8
    };
    _this.storeKeys = [_FeedbackReceiveStore.FEEDBACK_RECEIVE_STORE_PATHS.DATA_INITIALIZED, _FeedbackReceiveStore.FEEDBACK_RECEIVE_STORE_PATHS.DATA_ERROR, _FeedbackReceiveStore.FEEDBACK_RECEIVE_STORE_PATHS.FEEDBACKS];

    _this.mapStoreToState = function (feedbackReceiveStore, newState) {
      if (!_this.storeKeys) return newState;
      var doUpdate = false;
      var updateObj = {};

      for (var i = 0; i < _this.storeKeys.length; i++) {
        var prop = _this.storeKeys[i];

        if (newState.hasOwnProperty(prop)) {
          doUpdate = true;
          updateObj[prop] = newState[prop];

          if (prop === _FeedbackReceiveStore.FEEDBACK_RECEIVE_STORE_PATHS.FEEDBACKS) {
            var feedBacks = newState[_FeedbackReceiveStore.FEEDBACK_RECEIVE_STORE_PATHS.FEEDBACKS];

            if (_this.props.questionId && feedBacks && feedBacks.hasOwnProperty(_this.props.questionId)) {
              updateObj['answerStats'] = feedBacks[_this.props.questionId];
            }
          }
        }
      }

      return doUpdate ? updateObj : false;
    };

    (0, _get2["default"])((_thisSuper = (0, _assertThisInitialized2["default"])(_this), (0, _getPrototypeOf2["default"])(Voting.prototype)), "addStoresAndKeys", _thisSuper).call(_thisSuper, [{
      store: _FeedbackReceiveStore["default"],
      keys: _this.storeKeys
    }]);
    return _this;
  }

  (0, _createClass2["default"])(Voting, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      if (this.props.questionId && this.props.answers) {
        this._initAnswerLabels();

        this._updateAnswerValues(this.state);
      }

      if (_config["default"].votesViewOnly) {
        this.setState({
          voted: true,
          index: 1
        });
      }

      this.setState({
        chartWidth: this._chartContainer !== null ? this._chartContainer.offsetWidth : 500
      });

      if (this.props.inFeedbackContainer) {
        this.props.registerSendFunc(this.props.questionId, this.sendAnswers);
      }

      if (!_DeviceInfoHelper["default"].isBrowser()) {
        _ScreenHelper["default"].instance().addOnWindowSizeChangedListener(this.onWindowSizeChanged);

        window.screen.orientation.addEventListener('change', this.onWindowSizeChanged);
      }

      console.log('Voting did mount', this.props.forcedUIColor);

      if (this.props.forcedUIColor) {
        if (_config["default"].useTileBackgroundColorInTile) {
          _CssHelper["default"].addCssRule('.epr .voting ul li', "{color: ".concat(this.props.forcedUIColor, " !important}"));
        }
      }

      if (_DeviceInfoHelper["default"].isBrowser()) {
        window.addEventListener('keypress', function (event) {
          return _this2.checkEnterKey(event);
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this3 = this;

      if (!_DeviceInfoHelper["default"].isBrowser()) {
        _ScreenHelper["default"].instance().removeOnWindowSizeChangedListener(this.onWindowSizeChanged);

        window.screen.orientation.removeEventListener('change', this.onWindowSizeChanged);
      } else {
        window.removeEventListener('keypress', function (event) {
          return _this3.checkEnterKey(event);
        });
      }

      (0, _get2["default"])((0, _getPrototypeOf2["default"])(Voting.prototype), "componentWillUnmount", this).call(this);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      if (this.props.questionId !== prevProps.questionId) {
        this._initAnswerLabels();
      }

      if ((0, _stringify["default"])(prevState.answerStats) !== (0, _stringify["default"])(this.state.answerStats)) {
        this._updateAnswerValues(this.state);
      }
    }
  }, {
    key: "_arrayDiffs",
    value: function _arrayDiffs(arr1, arr2) {
      return arr1.length !== arr2.length || !arr1.every(function (v, i) {
        return v === arr2[i];
      });
    }
  }, {
    key: "_sendChange",
    value: function _sendChange(id) {
      if (this.props.singleChoice) {
        if (this.lastSend === null || this.lastSend !== id) {
          this.lastSend = id;
          (0, _FeedbackService.pushFeedbackMessage)(this.props.questionId, this.lastSend);
        }
      } else {
        var checked = this.state.selectedMCOptions;

        if (this.lastSend === null || this._arrayDiffs(this.lastSend, checked)) {
          this.lastSend = checked;
          (0, _FeedbackService.pushFeedbackMessage)(this.props.questionId, this.lastSend);
        }
      }

      this.setState({
        voted: true,
        index: 1
      });
    }
  }, {
    key: "renderPieChart",
    value: function renderPieChart() {
      var innerSize = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var container = document.getElementById('chartContainer');
      var renderData = this.chartData.slice();
      var pieData = [];
      renderData.forEach(function (entry) {
        pieData.push({
          name: entry.text,
          y: _config["default"].absoluteVoteResults ? entry.Stimmen : entry.Prozent
        });
      });
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _Voting["default"].pieChart
      }, /*#__PURE__*/_react["default"].createElement(_reactJsxHighcharts.HighchartsChart, null, /*#__PURE__*/_react["default"].createElement(_reactJsxHighcharts.Chart, null), /*#__PURE__*/_react["default"].createElement(_reactJsxHighcharts.Legend, {
        itemStyle: {
          textOverflow: null
        }
      }, /*#__PURE__*/_react["default"].createElement(_reactJsxHighcharts.Legend.Title, null, "Antworten")), /*#__PURE__*/_react["default"].createElement(_reactJsxHighcharts.YAxis, null, /*#__PURE__*/_react["default"].createElement(_reactJsxHighcharts.PieSeries, {
        dataLabels: {
          enabled: false,
          distance: 10,
          useHTML: true,
          style: {
            fontFamily: _cssConstants["default"].fontFamily,
            fontSize: '10px',
            wordBreak: 'break-all'
          }
        },
        center: ['50%', '50%'],
        innerSize: innerSize,
        colors: _cssConstants["default"].colors.donutChartColors ? _cssConstants["default"].colors.donutChartColors : null,
        data: pieData,
        showInLegend: true
      }))));
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var isAuthor = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.KESI_SHOW_UNPUBLISHED_CONTENT);

      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "voting",
        style: this.props.style,
        ref: function ref(component) {
          _this4._chartContainer = component;
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: this.props.inGalleryContainer ? 'titleSmall' : 'title',
        dangerouslySetInnerHTML: {
          __html: this.props.question
        }
      }), this.props.info && /*#__PURE__*/_react["default"].createElement("div", {
        className: "info ".concat(_Voting["default"].info),
        dangerouslySetInnerHTML: {
          __html: this.props.info
        }
      }), /*#__PURE__*/_react["default"].createElement(_reactSwipeableViews["default"], {
        disabled: true,
        index: this.state.index
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "answerContainer",
        style: {
          overflow: 'hidden',
          opacity: this.state.index === 0 ? 1 : 0,
          transition: 'opacity 200ms 200ms'
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _Voting["default"].answerContainer
      }, /*#__PURE__*/_react["default"].createElement("ul", {
        style: {
          width: '100%',
          listStyle: 'none',
          margin: '1em 0',
          padding: 0
        }
      }, this.renderAnswers())), !this.props.inFeedbackContainer && /*#__PURE__*/_react["default"].createElement("div", {
        className: _Voting["default"].buttonContainer
      }, /*#__PURE__*/_react["default"].createElement(_index["default"], {
        forcedColor: _config["default"].useTileBackgroundColorInTile ? this.props.forcedUIColor : _cssConstants["default"].colors.buttonBackground,
        className: _config["default"].useCenteredButtons ? _Voting["default"].centeredButton : _Voting["default"].button,
        onClick: function onClick() {
          _this4.sendAnswers();
        }
      }, (0, _strings.getString)('VOTE_NOW')))), this.props.hideResults && !isAuthor ? /*#__PURE__*/_react["default"].createElement("div", {
        id: "chartContainer",
        className: "chartContainer",
        style: {
          width: '100%',
          overflow: 'hidden',
          position: 'relative',
          height: '100%',
          opacity: this.state.index === 0 ? 0 : 1,
          transition: 'opacity 200ms 200ms'
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          position: 'absolute',
          left: '50%',
          top: '50%',
          transform: 'translate(-50%, -50%)',
          fontSize: '30px'
        }
      }, (0, _strings.getString)('HIDE_VOTE_RESULTS'))) : /*#__PURE__*/_react["default"].createElement("div", {
        id: "chartContainer",
        className: "chartContainer",
        style: {
          width: '100%',
          overflow: 'hidden',
          opacity: this.state.index === 0 ? 0 : 1,
          transition: 'opacity 200ms 200ms'
        }
      }, this.state[_FeedbackReceiveStore.FEEDBACK_RECEIVE_STORE_PATHS.DATA_INITIALIZED] && !this.state[_FeedbackReceiveStore.FEEDBACK_RECEIVE_STORE_PATHS.DATA_ERROR] && this.state.voted && this.props.presentationType === 'pie' && this.renderPieChart(), this.state[_FeedbackReceiveStore.FEEDBACK_RECEIVE_STORE_PATHS.DATA_INITIALIZED] && !this.state[_FeedbackReceiveStore.FEEDBACK_RECEIVE_STORE_PATHS.DATA_ERROR] && this.state.voted && this.props.presentationType === 'donut' && this.renderPieChart('40%'), this.state[_FeedbackReceiveStore.FEEDBACK_RECEIVE_STORE_PATHS.DATA_INITIALIZED] && !this.state[_FeedbackReceiveStore.FEEDBACK_RECEIVE_STORE_PATHS.DATA_ERROR] && this.state.voted && this.props.presentationType === 'bar' && this.renderBarChart())));
    }
  }]);
  return Voting;
}(_StoreComponent2["default"]);

Voting.propTypes = {
  style: _propTypes["default"].object,
  answers: _propTypes["default"].array,
  question: _propTypes["default"].string,
  questionId: _propTypes["default"].string,
  singleChoice: _propTypes["default"].bool,
  presentationType: _propTypes["default"].string,
  present: _propTypes["default"].bool,
  markAsRead: _propTypes["default"].func,
  inSwipeContainer: _propTypes["default"].bool,
  votingUpdated: _propTypes["default"].func,
  onVoted: _propTypes["default"].func,
  info: _propTypes["default"].string,
  hideResults: _propTypes["default"].bool,
  displayInline: _propTypes["default"].bool,
  forcedUIColor: _propTypes["default"].string
};

var _default = (0, _reactJsxHighcharts.withHighcharts)(Voting, _highcharts["default"]);

exports["default"] = _default;